import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import LanguagePicker from '../../common/languagePicker';

export const useNavLanguagePicker = ({ noLanguageSelector }) => {
  const LanguagePickerComponent = useMemo(() => {
    if (noLanguageSelector) {
      return null;
    }
    return <LanguagePicker />;
  }, [noLanguageSelector]);

  return LanguagePickerComponent;
};

useNavLanguagePicker.propTypes = {
  noLanguageSelector: PropTypes.bool,
};

useNavLanguagePicker.defaultProps = {
  noLanguageSelector: false,
};

export default useNavLanguagePicker;
